/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { BrowserModule, platformBrowser } from './browser';
export { Title } from './browser/title';
export { disableDebugTools, enableDebugTools } from './browser/tools/tools';
export { AnimationDriver } from './dom/animation_driver';
export { By } from './dom/debug/by';
export { NgProbeToken } from './dom/debug/ng_probe';
export { DOCUMENT } from './dom/dom_tokens';
export { EVENT_MANAGER_PLUGINS, EventManager } from './dom/events/event_manager';
export { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from './dom/events/hammer_gestures';
export { DomSanitizer } from './security/dom_sanitization_service';
export { __platform_browser_private__ } from './private_export';
export { VERSION } from './version';
//# sourceMappingURL=platform-browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/platform-browser.js
// module id = 466
// module chunks = 3